import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';
import { BlockDesktop as Block } from '@alfa-bank/site-block/desktop';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';
import { Aligner } from '@alfa-bank/site-aligner';

import type { TWrapperComponentDesktop } from '../models';

import styles from './styles.css';

export const ShadowBoxDesktop: FC<TWrapperComponentDesktop> = ({ children, title }) => {
    return (
        <Block
            className={cn(styles.wrapper, styles.external)}
            notPadded
            styler={{ paddingBottom: 48, paddingTop: 48, borderRadius: 32 }}
            theme={'white'}
        >
            {title ? (
                <Aligner styler={{ marginBottom: 24 }}>
                    <Text styler={{ marginTop: 0, marginBottom: 0 }} tag="h2" view="medium">
                        {title}
                    </Text>
                </Aligner>
            ) : null}
            {children}
        </Block>
    );
};
